import Api from './rest/ExternalContactApi';

export default new Api();
